/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const AgentReasoningConfigurationEffort = {
  Low: "low",
  Medium: "medium",
  High: "high",
} as const;
export type AgentReasoningConfigurationEffort = ClosedEnum<
  typeof AgentReasoningConfigurationEffort
>;

export type AgentReasoningConfiguration = {
  effort?: AgentReasoningConfigurationEffort | undefined;
};

/** @internal */
export const AgentReasoningConfigurationEffort$inboundSchema: z.ZodNativeEnum<
  typeof AgentReasoningConfigurationEffort
> = z.nativeEnum(AgentReasoningConfigurationEffort);
/** @internal */
export const AgentReasoningConfigurationEffort$outboundSchema: z.ZodNativeEnum<
  typeof AgentReasoningConfigurationEffort
> = AgentReasoningConfigurationEffort$inboundSchema;

/** @internal */
export const AgentReasoningConfiguration$inboundSchema: z.ZodType<
  AgentReasoningConfiguration,
  z.ZodTypeDef,
  unknown
> = z.object({
  effort: AgentReasoningConfigurationEffort$inboundSchema.optional(),
});
/** @internal */
export type AgentReasoningConfiguration$Outbound = {
  effort?: string | undefined;
};

/** @internal */
export const AgentReasoningConfiguration$outboundSchema: z.ZodType<
  AgentReasoningConfiguration$Outbound,
  z.ZodTypeDef,
  AgentReasoningConfiguration
> = z.object({
  effort: AgentReasoningConfigurationEffort$outboundSchema.optional(),
});

export function agentReasoningConfigurationToJSON(
  agentReasoningConfiguration: AgentReasoningConfiguration,
): string {
  return JSON.stringify(
    AgentReasoningConfiguration$outboundSchema.parse(
      agentReasoningConfiguration,
    ),
  );
}
export function agentReasoningConfigurationFromJSON(
  jsonString: string,
): SafeParseResult<AgentReasoningConfiguration, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AgentReasoningConfiguration$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AgentReasoningConfiguration' from JSON`,
  );
}
